import { Route } from "mobx-router"
import { logger } from "../lib/logger"
import type { RootStore } from "../stores/RootStore"
import { CallbackPage } from "./CallbackPage"
import { ContributorsPage } from "./ContributorsPage"
import { CustomDashboardPage } from "./CustomDashboardPage"
import { DoraMetricsPage } from "./DoraMetricsPage"
import { GitHubCallbackPage } from "./GitHubCallbackPage"
import { HomePage } from "./HomePage"
import { NotFoundPage } from "./NotFoundPage"
import { RepositoriesPage } from "./RepositoriesPage"
import { SettingsPage } from "./SettingsPage"
import { TeamsPage } from "./TeamsPage"

export const routes = {
  home: new Route<RootStore>({
    path: "/",
    component: <HomePage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering home route", { component: "Router" })
    },
  }),
  contributors: new Route<RootStore>({
    path: "/contributors",
    component: <ContributorsPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering contributors route", { component: "Router" })
    },
  }),
  contributorDetail: new Route<RootStore>({
    path: "/contributors/:handle",
    component: <ContributorsPage />,
    onEnter: (_route, params, _store) => {
      logger.debug("Entering contributor detail route", {
        component: "Router",
        handle: params?.handle,
      })
    },
  }),
  teams: new Route<RootStore>({
    path: "/teams",
    component: <TeamsPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering teams route", { component: "Router" })
    },
  }),
  teamDetail: new Route<RootStore>({
    path: "/teams/:teamName",
    component: <TeamsPage />,
    onEnter: (_route, params, _store) => {
      logger.debug("Entering team detail route", {
        component: "Router",
        teamName: params?.teamName,
      })
    },
  }),
  repositories: new Route<RootStore>({
    path: "/repositories",
    component: <RepositoriesPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering repositories route", { component: "Router" })
    },
  }),
  doraMetrics: new Route<RootStore>({
    path: "/dora-metrics",
    component: <DoraMetricsPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering DORA metrics route", { component: "Router" })
    },
  }),
  customDashboard: new Route<RootStore>({
    path: "/custom-dashboard",
    component: <CustomDashboardPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering custom dashboard route", { component: "Router" })
    },
  }),
  settings: new Route<RootStore>({
    path: "/settings",
    component: <SettingsPage />,
    onEnter: (_route, _params, _store) => {
      logger.debug("Entering settings route", { component: "Router" })
    },
  }),
  callback: new Route<RootStore>({
    path: "/callback",
    component: <CallbackPage />,
    onEnter: async (_route, _params, store) => {
      logger.debug("Callback route entered", { component: "Router" })
      await store.auth.handleCallback()
    },
  }),
  githubCallback: new Route<RootStore>({
    path: "/auth/github/callback",
    component: <GitHubCallbackPage />,
  }),
  notFound: new Route<RootStore>({
    path: "/404",
    component: <NotFoundPage />,
  }),
}
